module.exports = __webpack_public_path__ + "img/fgcover_sample.77189eab.png";